/** @jsx jsx */
import { useCallback, useMemo } from 'react';
import { jsx } from '@emotion/react';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { clearFormatting as clearFormattingKeymap, tooltip } from '@atlaskit/editor-common/keymaps';
import { toolbarMessages } from '@atlaskit/editor-common/messages';
import { shortcutStyle } from '@atlaskit/editor-shared-styles/shortcut';
import { clearFormattingWithAnalytics } from '../../../commands/clear-formatting';
import { pluginKey as clearFormattingPluginKey } from '../../../pm-plugins/clear-formatting';
var useClearFormattingPluginState = function useClearFormattingPluginState(editorState) {
  return useMemo(function () {
    return clearFormattingPluginKey.getState(editorState);
  }, [editorState]);
};
export var useClearIcon = function useClearIcon(_ref) {
  var intl = _ref.intl,
    editorState = _ref.editorState,
    editorAnalyticsAPI = _ref.editorAnalyticsAPI;
  var pluginState = useClearFormattingPluginState(editorState);
  var isPluginAvailable = Boolean(pluginState);
  var formattingIsPresent = Boolean(pluginState === null || pluginState === void 0 ? void 0 : pluginState.formattingIsPresent);
  var clearFormattingLabel = intl.formatMessage(toolbarMessages.clearFormatting);
  var clearFormattingToolbar = useCallback(function (state, dispatch) {
    return clearFormattingWithAnalytics(INPUT_METHOD.TOOLBAR, editorAnalyticsAPI)(state, dispatch);
  }, [editorAnalyticsAPI]);
  return useMemo(function () {
    if (!isPluginAvailable) {
      return null;
    }
    return {
      key: 'clearFormatting',
      command: clearFormattingToolbar,
      content: clearFormattingLabel,
      elemAfter:
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
      jsx("div", {
        css: shortcutStyle
      }, tooltip(clearFormattingKeymap)),
      value: {
        name: 'clearFormatting'
      },
      isActive: false,
      isDisabled: !formattingIsPresent,
      'aria-label': clearFormattingKeymap ? tooltip(clearFormattingKeymap, String(clearFormattingLabel)) : String(clearFormattingLabel)
    };
  }, [isPluginAvailable, clearFormattingToolbar, clearFormattingLabel, formattingIsPresent]);
};